// Auto generated file, do not manually modify!
// com.hotpads.leasing.api.web.v1.renewal.LeaseRenewalWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type {
  CanTenantAskForLeaseRenewalWebApiResponseDto,
  CreateLeaseRenewalWebApiRequestDto,
  CreateLeaseRenewalWebApiResponseDto,
  GetLeaseExtensionWebApiResponseDto,
} from '../..';

interface CanTenantAskForRenewalParams {
  leaseId: number;
}
interface GetLeaseExtensionParams {
  leaseExtensionId: number;
}

export const LeaseRenewalWebApiHandler_canTenantAskForRenewal_Path = '/api/web/v1/lease/renewal/canTenantAskForRenewal';

/**
 * is the current tenant and leaseId applicable for a renewal
 */
export const LeaseRenewalWebApiHandler_canTenantAskForRenewal = (
  getParams: CanTenantAskForRenewalParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<CanTenantAskForRenewalParams, never, CanTenantAskForLeaseRenewalWebApiResponseDto>(
    {
      getParams: getParams,
      endpoint: LeaseRenewalWebApiHandler_canTenantAskForRenewal_Path,
      method: 'GET',
      contextPath: '/leasing',
    },
    client,
  );
};

export const LeaseRenewalWebApiHandler_create_Path = '/api/web/v1/lease/renewal/create';

/**
 * create new lease renewal
 */
export const LeaseRenewalWebApiHandler_create = (
  postData: CreateLeaseRenewalWebApiRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, CreateLeaseRenewalWebApiRequestDto, CreateLeaseRenewalWebApiResponseDto>(
    {
      endpoint: LeaseRenewalWebApiHandler_create_Path,
      method: 'POST',
      contextPath: '/leasing',
      postData: postData,
    },
    client,
  );
};

export const LeaseRenewalWebApiHandler_getLeaseExtension_Path = '/api/web/v1/lease/renewal/getLeaseExtension';

/**
 * get lease extension
 */
export const LeaseRenewalWebApiHandler_getLeaseExtension = (
  getParams: GetLeaseExtensionParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<GetLeaseExtensionParams, never, GetLeaseExtensionWebApiResponseDto>(
    {
      getParams: getParams,
      endpoint: LeaseRenewalWebApiHandler_getLeaseExtension_Path,
      method: 'GET',
      contextPath: '/leasing',
    },
    client,
  );
};
